/* eslint-disable @typescript-eslint/camelcase */
import { ConvertObjectCamelToSnakeCase } from "@/app/infrastructures/misc/Utils";
import { CourierNotesPhoto } from "@/domain/entities/CodReconcile";
import { QueryParamsEntitiesV3 } from "@/domain/entities/MainApp";

export class GetCourierNotes {
  courierId = 0;
  date = "";
  reconcileFor = "";

  constructor(fields?: Partial<GetCourierNotes>) {
    Object.assign(this, fields);
  }

  get params() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { courierId, ...params } = this;
    return ConvertObjectCamelToSnakeCase(params);
  }
}

export class SubmitCourierNotes {
  courierId = 0;
  note = "";
  date = "";
  reconcileFor = "";

  constructor(fields?: Partial<SubmitCourierNotes>) {
    Object.assign(this, fields);
  }

  toJSON() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { courierId, ...payload } = this;
    return ConvertObjectCamelToSnakeCase(payload);
  }
}

export class SubmitCourierNotesPhotos {
  courierId = 0;
  date = "";
  photos: CourierNotesPhoto[] = [];
  reconcileFor = "";

  constructor(fields?: Partial<SubmitCourierNotesPhotos>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return JSON.stringify({
      date: this.date,
      reconcile_for: this.reconcileFor,
      photos: this.photos.map((photo) => ({
        url: photo.url,
        uploaded_at: photo.uploadedAt,
        uploaded_by: photo.uploadedBy,
        uploaded_by_type: photo.uploadedByType
      }))
    });
  }
}

export class TaskSettlementCourierParams {
  id = 0;
  reconcileStatus = "";
  reconcileFor = "";
  date = "";

  constructor(fields?: Partial<TaskSettlementCourierParams>) {
    Object.assign(this, fields);
  }

  toQueryString() {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}
